<template id="select-template">
  <div class="selector">
    <div role="button" @click="toggle">
      <slot name="button"></slot>
    </div>
    <div class="dropdown" v-show="show">
      <div class="dropdown-content">
        <slot name="content">
          <span class="item" v-for="(item, index) in items" :key="index" @click="select(item)">
            {{ item.label }}
          </span>
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  template: '#select-template',
  props: {
    items: {
      type: Array,
      required: false
    }
  },
  data() {
    return {
      show: false
    };
  },
  created() {
    window.addEventListener('click', this.close);
  },
  beforeDestroy() {
    window.removeEventListener('click', this.close);
  },
  methods: {
    toggle: function() {
      this.show = !this.show;
      this.$emit('toggle', this.show);
    },
    select: function(item) {
      this.show = false;
      this.$emit('selected', item);
      this.$emit('toggle', this.show);
    },
    close: function(event) {
      if (!this.$el.contains(event.target)) {
        this.show = false;
        this.$emit('toggle', this.show);
      }
    }
  }
};
</script>
